<div class="centered">
  <ng-content></ng-content>
</div>
